import { Favorecido, FuncaoService, GlobalService, LoginContabil, Relatorio } from "eddydata-lib";

export class AtestadoCapacidadeTecnicaRpt {


  private login: LoginContabil;
  private funcaoService: FuncaoService;

  constructor(login: LoginContabil) {
    this.login = login;
    this.funcaoService = new FuncaoService();
  }

  prestador: Favorecido;
  tomador: Favorecido;

  protected afterInit(): void {
    throw new Error("Method not implemented.");
  }

  protected modalRelatorio(): string {
    return 'atestado-capacidade-tecnica';
  }

  protected tituloRelatorio(): string {
    return "Atestado de capacidade técnica";
  }

  protected layoutRelatorio(): {} {
    return null;
  }

  protected montarConteudo(): Promise<{}[]> {
    return new Promise((resolve) => {
      resolve(this.montarAtestado());
    });
  }

  protected ocultarCabecalho(): boolean {
    return true;
  }

  private montarAtestado(): {}[] {
    let data = new Date();
    return [{
      stack: [
        { text: 'ATESTADO DE CAPACIDADE TÉCNICA', fontSize: 14, bold: true, margin: [0, 0, 0, 30] },
        {
          text: [`Atestamos, para os devidos fins, que a empresa `,
            { text: this.prestador ? this.prestador.nome : this.trasos(40), bold: true },
            `, inscrita no CNPJ sob o nº `, { text: this.prestador ? this.cpfCnpj(this.prestador.cpf_cnpj) : this.trasos(25), bold: true },
            `, estabelecida na Rua `, { text: this.prestador ? this.prestador.endereco : this.trasos(60), bold: true },
            `, nº `, { text: this.prestador ? this.prestador.num_endereco : this.trasos(10), bold: true },
            `, bairro `, { text: this.prestador ? this.prestador.bairro : this.trasos(40), bold: true },
            `, na cidade de `, { text: this.prestador ? this.prestador.cidade.nome : this.trasos(25), bold: true },
            `, Estado de `, { text: this.prestador ? this.prestador.uf : this.trasos(10), bold: true },
            `, prestou serviços à `, { text: this.tomador ? this.tomador.nome : this.trasos(40), bold: true },
            `, CNPJ nº `, { text: this.tomador ? this.cpfCnpj(this.tomador.cpf_cnpj) : this.trasos(25), bold: true },
            `, estabelecida na Rua `, { text: this.tomador ? this.tomador.endereco : this.trasos(60), bold: true },
            `, nº `, { text: this.tomador ? this.tomador.num_endereco : this.trasos(10), bold: true },
            `, bairro `, { text: this.tomador ? this.tomador.bairro : this.trasos(40), bold: true },
            `, na cidade de `, { text: this.tomador ? this.tomador.cidade.nome : this.trasos(25), bold: true },
            `, Estado de `, { text: this.tomador ? this.tomador.uf : this.trasos(10), bold: true },
            `,  detém qualificação técnica para ${this.trasos(80)}.

      Registramos que a empresa prestou serviços/entregou produtos ${this.trasos(200)}.
      
      Informamos ainda que as prestações dos serviços/entrega dos materiais acima referidos apresentaram bom desempenho operacional, tendo a empresa cumprido fielmente com suas obrigações, nada constando que a desabone técnica e comercialmente, até a presente data.`],
          fontSize: 13, alignment: 'justify',
          lineHeight: 1.5
        },
        { text: `${this.login.cidade.nome}, ${data.getDate()} de ${new GlobalService().obterMes(data.getMonth())} de ${data.getFullYear()}`, fontSize: 13, margin: [0, 25] },
        { text: this.trasos(50), fontSize: 13 },
        { text: this.prestador ? this.prestador.nome : '', fontSize: 13, margin: [0, 10, 0, 5] },
        { text: this.prestador ? this.cpfCnpj(this.prestador.cpf_cnpj) : '', fontSize: 13 },
        {
          text: this.prestador ? (`${this.prestador.endereco}, ${this.prestador.num_endereco}`) : '',
          fontSize: 13, alignment: 'center', bold: true, margin: [0, 30, 0, 0]
        }
      ], margin: [20, 100]
    }];
  }

  private cpfCnpj(doc: string) {
    if (doc.length > 11)
      return this.funcaoService.mascarar('##.###.###/####-##', doc);
    else
      return this.funcaoService.mascarar('###.###.###-##', doc);
  }


  private trasos(cols: number) {
    return Array.from(Array(cols).keys()).map((_, i) => {
      if (i % 2 === 0) return '_';
      else return ' '
    }).join('');
  }

  public imprimir(prestador: Favorecido, tomador: Favorecido) {
    this.prestador = prestador;
    this.tomador = tomador;
    this.montarConteudo().then((conteudo) => {
      Relatorio.imprimirPersonalizado(this.tituloRelatorio().toUpperCase(), this.login.usuario.nome,
        this.login.orgao.nome, this.login.brasao, conteudo, 'portrait', this.tituloRelatorio(),
        this.layoutRelatorio(), this.ocultarCabecalho(), true, 'pdf');
    })
  }
}